export const constantes = {
	
	locationInit: {lat: 48.558212, lng: 7.795242},
	//back : gmap.js, ligne 27
	
	serviceTypes : [
		{id: 'restaurant', label: 'Restaurant', dbvalue: 'restauration', markerSize:[47, 60]},
		{id: 'hotel', label: 'Hôtel', dbvalue: 'hôtel', markerSize:[47, 60]},
		{id: 'parkingVL', label: 'Voiture', dbvalue: 'parking', markerSize:[47, 60]},
		{id: 'parkingPL', label: 'Poids lourd', dbvalue: 'parking PL', markerSize:[47, 60]},
		{id: 'tourism', label: 'Tourisme', dbvalue: "points d'intérêt", markerSize:[47, 60]},
		{id: 'servicesauto', label: 'Services auto', dbvalue: 'stations-services', markerSize:[47, 60]},		
                {id: 'appontementcroisieriste', label: 'Appontement Croisièriste', dbvalue: 'appontements croisières', markerSize:[47, 60]},
                {id: 'appontementmarinier', label: 'Appontement Marinier', dbvalue: 'appontements mariniers', markerSize:[47, 60]},
                {id: 'appontementmixte', label: 'Appontement Mixte', dbvalue: 'appontements mixtes', markerSize:[47, 60]},
                {id: 'dechets', label: 'Tri des déchêts', dbvalue: 'espace de gestion des déchets', markerSize:[47, 60]},
		// {id: 'ferry', label: 'Écluse'}, 
	],
	
	/* 
	activities : [
		{label: 'TRANSPORTS ET LOGISTIQUE', value: 'TRANSPORTS ET LOGISTIQUE'},
		{label: 'INDUSTRIE Agroalimentaire', value: 'INDUSTRIE Agroalimentaire'},
		{label: 'INDUSTRIE Papier', value: 'INDUSTRIE Papier'},
		{label: 'INDUSTRIE Métallurgie', value: 'INDUSTRIE Métallurgie'},
		{label: 'INDUSTRIE Automobile', value: 'INDUSTRIE Automobile'},
		{label: 'INDUSTRIE Chimie', value: 'INDUSTRIE Chimie'},
		{label: 'VALORISATION DECHETS', value: 'VALORISATION DECHETS'},
		{label: "ADMINISTRATIONS et ORGANISMES D'INTERET GENERAL", value: "ADMINISTRATIONS et ORGANISMES D'INTERET GENERAL"},
		{label: 'MATERIAUX DE CONSTRUCTION / BTP', value: 'MATERIAUX DE CONSTRUCTION / BTP'},
		{label: 'CROISIERES et NAUTISME', value: 'CROISIERES et NAUTISME' },
		{label: 'ENERGIE Stockage hydrocarbures', value: 'ENERGIE Stockage hydrocarbures'},
		{label: 'ENERGIE Production', value: 'ENERGIE Production'},
		{label: 'SERVICES Data centers', value: 'SERVICES Data centers'},
		{label: 'SERVICES Services portuaires', value: 'SERVICES Services portuaires'},
		{label: 'SERVICES Divers', value: 'SERVICES Divers'},
	],
	*/
	
	
	//0 = y, - = bas
	//1 = x, - = gauche
	
	sectors: [
		{label: 'A', color: '#00A7E1', value: 'A', shiftLetterLocation: [0, 0.5]},
		{label: 'B', color: '#009579', value: 'B', shiftLetterLocation: [6.2, -1.4]},
		{label: 'C', color: '#76BC21', value: 'C', shiftLetterLocation: [-2.2, -0.5]},
		{label: 'D', color: '#EBA900', value: 'D', shiftLetterLocation: [2.5, 4.0]},
		{label: 'E', color: '#96460A', value: 'E', shiftLetterLocation: [-2.8, -4.4]},
		{label: 'F', color: '#FF5100', value: 'F', shiftLetterLocation: [0, 0.3]},
		{label: 'G', color: '#E1251B', value: 'G', shiftLetterLocation: [0.5, -2.3]},
		{label: 'H', color: '#E96BB0', value: 'H', shiftLetterLocation: [-2.5, 0]},
		{label: 'I', color: '#9D1D96', value: 'I', shiftLetterLocation: [0, 1]},
	],
	
	// onlineBaseUrl: 'https://pas.data-test.fr/carte-interactive/',
	onlineBaseUrl: 'https://www.strasbourg.port.fr/carte-interactive/',
	
	os: '', //set dynamically
	browser: '', //set dynamically
	
	userAddress: null,
	
	isLazyLoadingEnabled():boolean
	{
		return (this.os != 'mac' && this.browser != 'ie');
	}
};
